import type { ComponentProps, FC } from 'react';

type Props = ComponentProps<'svg'>;

export const ProperNyushoSCheckIcon: FC<Props> = (props) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3 6.5H19"
      stroke="black"
      strokeOpacity="0.54"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
    <path
      d="M3 15.5H19"
      stroke="black"
      strokeOpacity="0.54"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
    <circle cx="15.5" cy="11" r="2.2" fill="black" fillOpacity="0.54" />
  </svg>
);
